import { RadioGroupProps } from '@nx-ng/types';
import { FareRequest } from '../../../client/src';
import { formatSearchSelectionPath } from '../../fares/util/select-fare-descriptions';
import { CUSTOMER_TYPES_LOOKUP } from './format-customer-type-options';
import { TRAVEL_METHOD_LOOKUP } from './format-travel-method-options';
import { TRAVEL_TIME_LOOKUP } from './format-travel-time-options';
import { TRAVEL_ZONE_LOOKUP } from './format-travel-zone-options';

export const formatFilterTicketDescription = ({
  values = {},
  selectionsValid,
}: {
  values: Partial<FareRequest>;
  selectionsValid: boolean;
}): string => {
  if (!selectionsValid) {
    return '';
  }

  const customerType = findTitleInSelectionDefinition({
    value: values?.customerType,
    group: CUSTOMER_TYPES_LOOKUP,
  });
  const travelArea = findTitleInSelectionDefinition({
    value: values?.zone,
    group: TRAVEL_ZONE_LOOKUP,
  });
  const travelMethod = findTitleInSelectionDefinition({
    value: values?.travelMethod,
    group: TRAVEL_METHOD_LOOKUP,
  });
  const travelTime = findTitleInSelectionDefinition({
    value: values?.travelTime,
    group: TRAVEL_TIME_LOOKUP,
  });

  return formatSearchSelectionPath({
    customerType,
    travelArea,
    travelMethod,
    travelTime,
  });
};

export const findTitleInSelectionDefinition = ({
  value,
  group,
}: {
  value?: string;
  group: RadioGroupProps<string>;
}) => {
  if (!value) {
    return '';
  }
  const standardItem = group?.standard?.find((item) => item.value === value);
  if (standardItem) {
    return standardItem.titleKey;
  }
  const additionalItem = group?.standard?.find((item) => item.value === value);
  if (additionalItem) {
    return additionalItem.titleKey;
  }
  return '';
};
